export default __webpack_public_path__ + "static/media/error.694b4357.png";